import { LatLng } from "leaflet";
import { useMap, useMapEvents } from "react-leaflet";
import { useSearchParams } from "react-router-dom";

export function PersistMapPosition() {
  const [queryParams, setQueryParams] = useSearchParams();
  const map = useMap();

  useMapEvents({
    moveend: () => {
      persistMapLocation(map.getCenter(), map.getZoom());
    },
  });

  function persistMapLocation(center: LatLng, zoom: number) {
    const updatedParams = new URLSearchParams(queryParams);

    updatedParams.set("lat", center.lat.toString());
    updatedParams.set("lon", center.lng.toString());
    updatedParams.set("zoom", zoom.toString());

    setQueryParams(updatedParams);
  }

  // render the component empty
  return null;
}
